module.exports = __webpack_public_path__ + "img/icon-email.1300a515.svg";